/* Read-only progressive enhancement. Never reads or changes carts, variants or forms. */
(() => {
  const selector = '.gift-finder-v2__product, .seife-pairing';
  const seen = new WeakSet(), requests = new Map();
  const locale = document.documentElement.lang.split('-')[0];
  const label = { de: 'Bewertungen', en: 'reviews', fr: 'avis', ar: 'تقييمات' }[locale] || 'reviews';
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      observer.unobserve(entry.target);
      enhance(entry.target);
    }
  });
  async function enhance(card) {
    const title = card.querySelector('h3'), link = card.querySelector('a[href*="/products/"]');
    if (!title || !link) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin) return;
    url.search = '';
    url.hash = '';
    const productUrl = url.href;
    url.searchParams.set('section_id', 'seife-review-rating');
    if (!requests.has(productUrl)) {
      requests.set(productUrl, fetch(url, { signal: AbortSignal.timeout(8000) }).then(async response => {
        if (!response.ok) return null;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const badge = doc.querySelector('[data-review-product] [data-average-rating][data-number-of-reviews]');
        if (!badge) return null;
        const rating = Number(badge.dataset.averageRating), count = Number(badge.dataset.numberOfReviews);
        return Number.isFinite(rating) && rating > 0 && rating <= 5 && Number.isInteger(count) && count > 0
          ? { rating, count } : null;
      }).catch(() => null));
    }
    const result = await requests.get(productUrl);
    if (!result || !card.isConnected) return; // No invented ratings or disruption when unavailable.
    const badge = document.createElement('a');
    badge.className = 'seife-review-summary seife-review-summary--card';
    badge.href = `${productUrl}#product-reviews`;
    badge.textContent = `★ ${new Intl.NumberFormat(locale, { maximumFractionDigits: 1 }).format(result.rating)}/5 · ${result.count} ${label}`;
    title.parentElement.tagName === 'A' ? title.parentElement.after(badge) : title.after(badge);
  }
  function scan(root) {
    if (!(root instanceof Element)) return;
    const cards = [...root.querySelectorAll(selector)];
    if (root.matches(selector)) cards.push(root);
    for (const card of cards) if (!seen.has(card)) { seen.add(card); observer.observe(card); }
  }
  scan(document.body);
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) scan(node);
  }).observe(document.body, { childList: true, subtree: true });
})();
